import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import { LocalStorageService } from "../services/local-storage/local-storage";
const localStorageService: LocalStorageService = new LocalStorageService();

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    react: {
      useSuspense: false,
    },
    lng: localStorageService.getData("lang") || "DE",
    fallbackLng: "EN",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: (lngs: string[], namespaces: string[]) => {
        console.log(lngs, namespaces);
        // Convert language code to lowercase for file path
        const lng = lngs[0]?.toLowerCase() || "de";
        return `/locales/${lng}/${namespaces[0]}.json`;
      },
    },
  });

export default i18n;
